import React, {useEffect, useMemo, useState} from "react";
import {Box, Button, CircularProgress, Grid, IconButton, TextField, Typography} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import {useDispatch} from "react-redux";
import {addYears, parseISO} from "date-fns";
import { log } from "../../utils/log";
import {iAluno} from "../../types/iAluno";
 import * as yup from "yup";
 import format from "date-fns/format";
import {
    DatePickerElement,
    SelectElement,
    TextFieldElement
} from "react-hook-form-mui";
 import {useForm} from "react-hook-form";
import {postAluno, postPictureFile} from "../../store/actions/alunosActions";
import { useYupValidationResolver } from "../../utils/utils";
import {newAluno} from "../../types/Aluno";
import PictureUpload from "../../components/CustomUpload/PictureUpload";
import config from "../../config";
import { lookupCep } from "../../utils/cepLookup";
import { useSnackbar } from "notistack";


const sxStyles = {
    mainGrid: {
    
    },
    fieldGrid: {
     p:1
    },
    paperGrid: {
        display: 'flex',
        flexDirection: 'row',
        alignContent: 'flex-start',
        flexWrap: 'wrap',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: '10px',
        borderColor: '#706d6d',
        mb:1
        
    }
}

interface iAlunoInfPessoaisDialog {
    recId?: number | null,
    // @ts-ignore
    registro?: iAluno
}

const d18anos = addYears(new Date(), -18);
const d80anos = addYears(new Date(), -80);


const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

const yupSchema = yup.object().shape({
    Name: yup.string().uppercase().trim().required("Nome obrigatório"),
    NomeSocial: yup.string().uppercase().trim().required("Nome Social obrigatório"),
    Mother: yup.string().uppercase().trim().required("Mãe obrigatório"),
    email: yup.string().email().trim().required("email obrigatório"),
    MobileNumber: yup.string().matches(phoneRegExp, "Formato telefone inválido").required("Celular obrigatório"),
    IndividualIdentity: yup.string().trim().required("CPF obrigatório"),
    BirthDate: yup.date()
            .max(d18anos, `Mínimo 18 anos. Data deve ser menor que ${format(d18anos,"dd/MM/yyyy")}  `)
            .min(d80anos, "Máximo 80 anos")
            .required("Data nascimento obrigatório")
});



const AlunoInfPessoais = ( props: iAlunoInfPessoaisDialog ) => {
    const resolver = useYupValidationResolver(yupSchema);
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [cepLoading, setCepLoading] = useState(false);
    
    const { control, handleSubmit,
        reset, getValues, setValue,
        formState: { isDirty, errors } } =
                useForm<Partial<iAluno>>({
                resolver: resolver,
                mode: 'all',
                reValidateMode: 'onChange',
                defaultValues: useMemo(() => {
                    
                    let obj = {
                        ...props.registro
                    }
                  
                    if (( typeof(props.registro) === "undefined") || ( typeof(props.registro?.id) == "undefined" || props.registro.id === null )) {
                        obj = {
                            ...newAluno
                        }
                    }
                    
                   
                    if ( props.registro &&  (typeof(props.registro.Name) !== "undefined") &&
                        (props.registro.NomeSocial === null || props.registro.NomeSocial === "")) {
                        obj.NomeSocial = props.registro.Name;
                       
                    }
                    
                    
                    return obj;
                }
                ,[props.registro]),
            });
    const [pictureFile, setPictureFile] = useState<string | null | undefined>(null);
    
    
    let renderCount = 0;
    
    useEffect(()=>{
        log(2, "AlunoInfPessoais", "useEffect", "props.registro", props.registro);
        const reg = { ...props.registro };
         setPictureFile(reg.PictureFile);
         reset({ ...reg});
    },[props.registro])
    
    const onImageSelected = (file:string) => {
        //console.log('image selected ', file);
        setPictureFile(file);
        if (props.registro && props.registro.id && props.registro.id > 0) {
            dispatch(postPictureFile(props.registro.id, file));
        }
    }
    
    const onSubmit = (data: any) => {
        log(3,"InfPessoais", JSON.stringify(data, null, 4));
        if (isDirty) { dispatch(postAluno(data, pictureFile)) };
      //   props.dialogState(false);
    }
    
    const consultaCEP = async (cep: string | undefined) => {
        if (!cep) return;
        setCepLoading(true);
        try {
            const result = await lookupCep(cep);
            if (result) {
                setValue("Address", result.logradouro.toString().toUpperCase());
                setValue("Address2", result.complemento.toString().toUpperCase());
                setValue("StreetNumber", "");
                setValue("Neighborhood", result.bairro.toString().toUpperCase());
                setValue("City", result.localidade.toString().toUpperCase());
                setValue("StateAddress", result.uf.toString().toUpperCase());
            } else {
                enqueueSnackbar("CEP nao encontrado", { variant: "error" });
            }
        } catch (e) {
            enqueueSnackbar("Erro ao consultar CEP", { variant: "error" });
            console.error("consultaCEP error:", e);
        } finally {
            setCepLoading(false);
        }
    }
    
    
    log(3,"AlunoInfPessoais", "renderCount", renderCount);
    
    const pictureUrl = pictureFile ? config.BASE_URL + pictureFile : null;
   
    return (
        <React.Fragment>
          
                <form onSubmit={handleSubmit(onSubmit)} >
                <Grid>
                    <Grid container sx={{...sxStyles.mainGrid, }}>
                        <p style={{color: "red"}}>{errors.Name?.message}</p>
                        <p style={{color: "red"}}>{errors.NomeSocial?.message}</p>
                        <p style={{color: "red"}}>{errors.Mother?.message}</p>
                        <p style={{color: "red"}}>{errors.email?.message}</p>
                        <p style={{color: "red"}}>{errors.MobileNumber?.message}</p>
                        <p style={{color: "red"}}>{errors.IndividualIdentity?.message}</p>
                        <p style={{color: "red"}}>{errors.BirthDate?.message}</p>

                        <Grid item container id={'paperIdentificacao'} sx={{...sxStyles.paperGrid, }}  sm={12} md={12} lg={12} xl={12} >
                            <Grid item container sx={{...sxStyles.fieldGrid, display: 'flex',flexDirection: 'row', flexWrap: 'wrap' }}  sm={12} md={12} lg={10} xl={10} >
                                <Grid item sx={{...sxStyles.fieldGrid, p:0}}  sm={12} md={12} lg={12} xl={12} >
                                    <TextFieldElement
                                        control={control}
                                        required={true}
                                        margin={'dense'}
                                        label={'NOME DE REGISTRO'}
                                        name={'Name'}
                                        fullWidth={true}
                                    />
                                    {/*<p style={{color: "red"}}>{errors.Name?.message}</p>*/}
                                </Grid>
                                <Grid item sx={{...sxStyles.fieldGrid, p:0 }}   sm={12} md={12} lg={1} xl={1} >
                                    <Button
                                        type="button"
                                        variant="contained"
                                        color="primary"
                                        onClick={ () => {  setValue('NomeSocial',getValues("Name")) } }
                                    >{'=>'}</Button>
                                </Grid>
                                <Grid item sx={{...sxStyles.fieldGrid, p:0 }}  sm={12} md={12} lg={11} xl={11} >
                                <TextFieldElement
                                    control={control}
                                    required={true}
                                    margin={'dense'}
                                    label={'NOME SOCIAL'}
                                    name={'NomeSocial'}
                                    fullWidth={true}
                                />
                               
                            </Grid>
                            </Grid>
                            <Grid item container sx={{...sxStyles.fieldGrid, justifyContent: 'center', display: 'flex',flexDirection: 'row', flexWrap: 'wrap'}}  sm={12} md={12} lg={2} xl={2} >
                                <Grid item container sx={{ width:'100%', maxWidth: '100%', height:'100%', maxHeight: '100%'}} lg={12} xl={12}>
                                    <PictureUpload
                                        imgSrc={pictureUrl}
                                        onFileChange={(f: string) => onImageSelected(f)}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={2} xl={2} >
                                <TextFieldElement
                                    control={control}
                                    required={true}
                                    margin={'dense'}
                                    label={'CPF'}
                                    name={'IndividualIdentity'}
                                    fullWidth={true}
                                />
                             
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={3} xl={3} >
                                <TextFieldElement
                                    control={control}
                                    required={true}
                                    margin={'dense'}
                                    label={'EMAIL'}
                                    name={'email'}
                                    type={'email'}
                                    fullWidth={true}
                                   
                                />
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={3} xl={3} >
                                <TextFieldElement
                                    control={control}
                                    required={true}
                                    margin={'dense'}
                                    label={'CELULAR'}
                                    name={'MobileNumber'}
                                    fullWidth={true}
                                />
                            </Grid>
                          
                            <Grid id={'gridEspaco'} item sx={{...sxStyles.fieldGrid, flexGrow: 3 }}   sm={12} md={12} lg={3} xl={3} >
                            </Grid>
                            
                            <Grid id={'gridDataNasc'} item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={2} xl={2} >
                                <DatePickerElement
                                    control={control}
                                    label="DATA NASC."
                                    name="BirthDate"
                                    required
                                    
                                />
                            </Grid>
                            
                          
                            
                            <Grid item sx={{...sxStyles.fieldGrid,flexGrow: 2  }}   sm={12} md={12} lg={2} xl={2} >
                                <SelectElement
                                    control={control}
                                    required={true}
                                    label="SEXO"
                                    name="Gender"
                                    options={[
                                        {
                                            id: 0,
                                            label: 'NAO INFORMADO'
                                        },
                                        {
                                            id: 1,
                                            label: 'MASCULINO'
                                        },
                                        {
                                            id: 2,
                                            label: 'FEMININO'
                                        }
                                    ]}
                                    fullWidth={true}
                                />
                             
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid, flexGrow: 2 }}   sm={12} md={12} lg={2} xl={2} >
                                <SelectElement
                                    control={control}
                                    required={true}
                                    label="ESTADO CIVIL"
                                    name="MaritalStatus"
                                    options={[
                                        {
                                            id: 0,
                                            label: 'NAO INFORMADO'
                                        },
                                        {
                                            id: 1,
                                            label: 'SOLTEIRO'
                                        },
                                        {
                                            id: 2,
                                            label: 'CASADO'
                                        },
                                        {
                                            id: 3,
                                            label: 'DIVORCIADO'
                                        },
                                        {
                                            id: 4,
                                            label: 'VIUVO'
                                        },
                                        {
                                            id: 5,
                                            label: 'UNIAO ESTAVEL'
                                        }
                                    ]}
                                />
                               
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid,flexGrow: 2  }}   sm={12} md={12} lg={2} xl={2} >
                                <SelectElement
                                    control={control}
                                    required={true}
                                    label="COR-RAÇA"
                                    name="CorRaca"
                                    options={[
                                        {
                                            id: 0,
                                            label: 'NAO DECLARADO'
                                        },
                                        {
                                            id: 1,
                                            label: 'BRANCA'
                                        },
                                        {
                                            id: 2,
                                            label: 'PRETA'
                                        }
                                        ,
                                        {
                                            id: 3,
                                            label: 'PARDA'
                                        }
                                        ,
                                        {
                                            id: 4,
                                            label: 'AMARELA'
                                        }
                                        ,
                                        {
                                            id: 5,
                                            label: 'INDIGENA'
                                        }
                                    ]}
                                    fullWidth={true}
                                />
                            
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={5} xl={5} >
                                <TextFieldElement
                                    control={control}
                                    margin={'none'}
                                    label={'MÃE'}
                                    name={'Mother'}
                                    fullWidth={true}
                                    required={true}
                                />
                            </Grid>
                            
                        </Grid>
                        <Grid item container id={'paperComentarios'} sx={{...sxStyles.paperGrid, }}  sm={12} md={12} lg={12} xl={12} >
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={12} xl={12} >
                                <TextFieldElement
                                    control={control}
                                    margin={'dense'}
                                    label={'COMENTARIOS'}
                                    name={'Comment'}
                                    fullWidth={true}
                                    multiline
                                    minRows={3}
                                    maxRows={3}
                                />
                            </Grid>
                        </Grid>
                        <Grid item container id={'paperSocial'} sx={{...sxStyles.paperGrid, }}  sm={12} md={12} lg={12} xl={12} >
                           
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={6} xl={6} >
                                <TextFieldElement
                                    control={control}
                                    margin={'dense'}
                                    label={'PAI'}
                                    name={'Father'}
                                    fullWidth={true}
                                />
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={2} xl={2} >
                                <TextFieldElement
                                    control={control}
                                    margin={'dense'}
                                    label={'LOCAL NASC'}
                                    name={'BirthPlace'}
                                    fullWidth={true}
                                />
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={2} xl={2} >
                                <TextFieldElement
                                    control={control}
                                    margin={'dense'}
                                    label={'NACIONALIDADE'}
                                    name={'Nationality'}
                                    fullWidth={true}
                                />
                            </Grid>
                        </Grid>
                        <Grid item container id={'paperDocumentos'} sx={{...sxStyles.paperGrid, }}  sm={12} md={12} lg={12} xl={12} >
                          
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={2} xl={2} >
                                <TextFieldElement
                                    control={control}
                                    margin={'dense'}
                                    label={'IDENTIDADE'}
                                    name={'IdentityNumber'}
                                    fullWidth={true}
                                />
                              
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={1} xl={1} >
                                <TextFieldElement
                                    control={control}
                                    margin={'dense'}
                                    label={'EMISSOR'}
                                    name={'IdentityEmitter'}
                                    fullWidth={true}
                                />
                            </Grid>
                            
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={2} xl={2} >
                                {/*<TextFieldController control={control} fullWidth={true} name="ElectionIdentity" label="TITULO ELEITORAL" />*/}
                                {/*<p style={{color: "red"}}>{errors.ElectionIdentity?.message}</p>*/}
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={1} xl={1} >
                                {/*<TextFieldController control={control} fullWidth={true} name="ElectionZone" label="ZONA" />*/}
                                {/*<p style={{color: "red"}}>{errors.ElectionZone?.message}</p>*/}
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={2} xl={2} >
                                <TextFieldElement
                                    control={control}
                                    margin={'dense'}
                                    label={'IDENTIDADE MILITAR'}
                                    name={'MilitarIdentity'}
                                    fullWidth={true}
                                />
                              
                            </Grid>
                        </Grid>
                        <Grid item container id={'paperEndereco'} sx={{...sxStyles.paperGrid, }}  sm={12} md={12} lg={12} xl={12} >
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={2} xl={2} >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                    <TextFieldElement
                                        control={control}
                                        margin={'dense'}
                                        label={'CEP'}
                                        name={'ZipCode'}
                                        fullWidth={true}
                                    />
                                    <IconButton
                                        color="primary"
                                        disabled={cepLoading}
                                        onClick={ async ()=> {
                                            if (typeof(getValues("ZipCode")) === "string" && getValues("ZipCode") !== "") {
                                                await consultaCEP(getValues("ZipCode"));
                                            }
                                        }}
                                        sx={{ mt: 0.5 }}
                                    >
                                        {cepLoading ? <CircularProgress size={24} /> : <SearchIcon />}
                                    </IconButton>
                                </Box>
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={6} xl={6} >
                                <TextFieldElement
                                    control={control}
                                    margin={'dense'}
                                    label={'ENDEREÇO'}
                                    name={'Address'}
                                    fullWidth={true}
                                />
                                {/*<TextFieldController control={control} fullWidth={true} name="Address" label="ENDEREÇO" />*/}
                                {/*<p style={{color: "red"}}>{errors.Address?.message}</p>*/}
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={1} xl={1} >
                                <TextFieldElement
                                    control={control}
                                    margin={'dense'}
                                    label={'No'}
                                    name={'StreetNumber'}
                                    fullWidth={true}
                                />
                                {/*<TextFieldController control={control} fullWidth={true} name="StreetNumber" label="No" />*/}
                                {/*<p style={{color: "red"}}>{errors.StreetNumber?.message}</p>*/}
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={3} xl={3} >
                                <TextFieldElement
                                    control={control}
                                    margin={'dense'}
                                    label={'COMPLEMENTO'}
                                    name={'Address2'}
                                    fullWidth={true}
                                />
                                {/*<TextFieldController control={control} fullWidth={true} name="Address2" label="COMPLEMENTO" />*/}
                                {/*<p style={{color: "red"}}>{errors.Address2?.message}</p>*/}
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={3} xl={3} >
                                <TextFieldElement
                                    control={control}
                                    margin={'dense'}
                                    label={'BAIRRO'}
                                    name={'Neighborhood'}
                                    fullWidth={true}
                                />
                                {/*<TextFieldController control={control} fullWidth={true} name="Neighborhood" label="BAIRRO" />*/}
                                {/*<p style={{color: "red"}}>{errors.Neighborhood?.message}</p>*/}
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={3} xl={3} >
                                <TextFieldElement
                                    control={control}
                                    margin={'dense'}
                                    label={'MUNICIPIO'}
                                    name={'City'}
                                    fullWidth={true}
                                />
                                {/*<TextFieldController control={control} fullWidth={true} name="City" label="MUNICIPIO" />*/}
                                {/*<p style={{color: "red"}}>{errors.City?.message}</p>*/}
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={1} xl={1} >
                                <TextFieldElement
                                    control={control}
                                    margin={'dense'}
                                    label={'ESTADO'}
                                    name={'StateAddress'}
                                    fullWidth={true}
                                />
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={2} xl={2} >
                                <TextFieldElement
                                    control={control}
                                    margin={'dense'}
                                    label={'2o TELEFONE'}
                                    name={'PhoneNumber'}
                                    fullWidth={true}
                                />
                            </Grid>
                        </Grid>
                        <Grid item container id={'paperEmpresa'} sx={{...sxStyles.paperGrid, }}  sm={12} md={12} lg={12} xl={12} >
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={5} xl={5} >
                                <TextFieldElement
                                    control={control}
                                    margin={'dense'}
                                    label={'EMPRESA'}
                                    name={'WorkAt'}
                                    fullWidth={true}
                                />
                                {/*<TextFieldController control={control} fullWidth={true} name="WorkAt" label="EMPRESA" />*/}
                                {/*<p style={{color: "red"}}>{errors.WorkAt?.message}</p>*/}
                            </Grid>
                            <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={2} xl={2} >
                                <TextFieldElement
                                    control={control}
                                    margin={'dense'}
                                    label={'TELEFONE'}
                                    name={'ProfPhone'}
                                    fullWidth={true}
                                />
                            </Grid>
                           
                        </Grid>
                        { props.registro && props.registro.user && props.registro.user.id === props.registro.FermiUser_id &&
                            <Grid item container id={'paperUsuario'} sx={{...sxStyles.paperGrid, }}  sm={12} md={12} lg={12} xl={12} >
                                <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={2} xl={2} >
                                    <TextField
                                        id="outlined-read-only-input"
                                        label="USUARIO"
                                        defaultValue={props.registro.user.username}
                                        InputProps={{
                                             readOnly: true,
                                        }}
                                    />
                                </Grid>
                                <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={2} xl={2} >
                                    <TextField
                                        id="outlined-read-only-input"
                                        label="ID USUARIO"
                                        defaultValue={props.registro.user.id}
                                        InputProps={{
                                             readOnly: true,
                                        }}
                                    />
                                </Grid>
                                <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={2} xl={2} >
                                    <TextField
                                        id="outlined-read-only-input"
                                        label="ESTUDANTE"
                                        defaultValue={props.registro.user.isStudent}
                                        InputProps={{
                                             readOnly: true,
                                        }}
                                    />
                                </Grid>
                                <Grid item sx={{...sxStyles.fieldGrid, }}   sm={12} md={12} lg={2} xl={2} >
                                    <TextFieldElement
                                        control={control}
                                        margin={'none'}
                                        label={'SENHA'}
                                        name={'user.password'}
                                        fullWidth={true}
                                    />
                                </Grid>
                                <Typography variant="caption">O usuario padrão é o primeiro CPF informado ao aluno, enquanto a senha padrão é o primeiro nome do aluno. Somente usuarios com permissoes especiais podem alterar a senha do aluno, podendo esta ser editada para igual/maior que 4 caracteres.</Typography>
                            </Grid>
                        }
                        
                    </Grid>
                    <Grid container sx={{...sxStyles.mainGrid, }}>
                        { isDirty &&
                            <React.Fragment>
                                <Button type="submit" >SALVAR</Button>
                            </React.Fragment>
                        }
                    </Grid>
                    
                </Grid>
                </form>
   
         
    </React.Fragment>);
    
}

export default (AlunoInfPessoais);

